import React, {useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {ChatModalView} from "./chat-modal.view";
import {StringParam, useQueryParam} from "use-query-params";
import {currentPerson, usePerson} from "@betrue/front/services";
import {Person} from "@betrue/shared/interfaces";

export const ChatModalPropsTypes = {

  chatWindowWidth: PropTypes.string,
  chatWindowHeight: PropTypes.string,
  landingChannel: PropTypes.string,
  openByDefault: PropTypes.string,
  refreshPerson: PropTypes.string,



}
export type ChatModalProps = InferProps<typeof ChatModalPropsTypes>


export const ChatModal = (props: ChatModalProps) => {

  const [notificationCount, setNotificationCount] = useState<number>(0)

  const [person, {updatePerson, getPersonById}] = usePerson<Person>(currentPerson)

  const [landingChat,] = useQueryParam('landing', StringParam);

  window.addEventListener('message', function (e) {
    if (e.data.eventName === 'unread-changed') {
      setNotificationCount(e.data.data ? e.data.data : 0)

    }

    if (e.data.eventName === 'unread-changed-by-subscription' && person && !person.chatId && props.refreshPerson === "true") {
      getPersonById(person.id)
    }

  });
  return (
    <ChatModalView {...props} notificationCount={notificationCount} landing={landingChat}/>
  );
}


ChatModal.propTypes = ChatModalPropsTypes
